module.exports = __webpack_public_path__ + "img/packaged.fa646756.png";